import { Outlet } from 'react-router';

import { FullWidthContainer } from '@sorare/core/src/atoms/layout/FullWidthContainer';

const ScoutingCenterLayout = () => {
  return (
    <FullWidthContainer.NoPadding>
      <Outlet />
    </FullWidthContainer.NoPadding>
  );
};

export default ScoutingCenterLayout;
